import { createStyles, Theme } from '@material-ui/core/styles';

import { colours, hexToRgba } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {},
    skeleton: {
      background: colours.neutral[50],
      bottom: 0,
      display: 'flex',
      left: 0,
      position: 'fixed',
      right: 0,
      top: 0,
      zIndex: 1299,
    },
    skeletonSidebar: {
      background: colours.brandNavy[900],
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      height: '100%',
      padding: spacing(4, 1.5, 3),
      width: 210,
    },
    skeletonLogo: {
      background: hexToRgba(colours.solid.white, 0.15),
      borderRadius: 4,
      height: 24,
      marginBottom: spacing(4),
      width: 80,
    },
    skeletonMenuItem: {
      background: hexToRgba(colours.solid.white, 0.08),
      borderRadius: 6,
      height: 36,
      marginBottom: spacing(0.5),
      width: '100%',
    },
    skeletonMenuItemActive: {
      background: hexToRgba(colours.solid.white, 0.15),
    },
    skeletonMenuSpacer: {
      height: 24,
    },
    skeletonMainArea: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
    },
    skeletonNav: {
      background: colours.solid.white,
      borderBottom: `1px solid ${colours.neutral[200]}`,
      display: 'flex',
      flexShrink: 0,
      gap: spacing(3),
      height: 48,
      padding: spacing(0, 3),
    },
    skeletonNavTab: {
      background: colours.neutral[200],
      borderRadius: 4,
      height: 14,
      marginTop: spacing(2),
      width: 72,
    },
    skeletonContent: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      gap: spacing(2),
      padding: spacing(3),
    },
    skeletonBlock: {
      background: colours.neutral[200],
      borderRadius: 6,
      height: 120,
      width: '100%',
    },
    skeletonBlockSmall: {
      background: colours.neutral[200],
      borderRadius: 6,
      height: 32,
      width: '40%',
    },
    headerCloseButton: {
      display: 'none',
    },
    body: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
      overflow: 'auto',
    },
    loadingContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      minHeight: 400,
    },
    page: {
      '& canvas': {
        height: 'auto !important',
        maxWidth: '100%',
      },
    },
    errorContainer: {
      alignItems: 'center',
      color: colours.error[500],
      display: 'flex',
      justifyContent: 'center',
      minHeight: 400,
    },
    footerActions: {
      alignItems: 'center',
      display: 'flex',
      gap: spacing(2),
    },
  });
